import React, { useState, useContext, useEffect } from 'react';
import { Paper, Select, MenuItem, Grid } from '@material-ui/core';
import { FBMAccountPicker } from '../../../shared';
import { UserContext } from '../../../contexts/UserContext';

import { ViewReceivingDiscrepancy } from './reports/viewReceivingDiscrepancy';
import { ViewPackagingInventory } from './reports/viewPackagingInventory';
import { ViewOnTimeDelivery } from './reports/viewOnTimeDelivery';
import { ViewExternalSkuUsage } from './reports/viewExternalSkuUsage';
import { ViewDailySkuPack } from './reports/viewDailySkuPack';
import { ViewOrderPackagingData } from './reports/viewOrderPackagingData';

const FBMViewReports = () => {
    const { fbmAccount } = useContext(UserContext);

    let reportList = [
        {
            id: 'receiving-discrepancy',
            displayName: 'Receiving Discrepancy',
        },
        {
            id: 'packaging-inventory',
            displayName: 'Packaging Inventory',
        },
        {
            id: 'on-time-delivery',
            displayName: 'On Time Delivery',
        },
        {
            id: 'external-sku-usage',
            displayName: 'External Sku Usage',
        },
        {
            id: 'daily-sku-pack',
            displayName: 'Daily Sku Pack',
        },
        {
            id: 'order-packaging-data',
            displayName: 'Order Packaging Data',
        },
    ];

    let [currentReport, setCurrentReport] = useState(reportList[0].id);

    let handleSelectReportChange = (event) => {
        setCurrentReport(event.target.value);
    };

    const renderSelectedReport = () => {
        switch (currentReport) {
            case 'receiving-discrepancy':
                return <ViewReceivingDiscrepancy />;
            case 'packaging-inventory':
                return <ViewPackagingInventory />;
            case 'on-time-delivery':
                return <ViewOnTimeDelivery />;
            case 'external-sku-usage':
                return <ViewExternalSkuUsage />;
            case 'daily-sku-pack':
                return <ViewDailySkuPack />;
            case 'order-packaging-data':
                return <ViewOrderPackagingData />;
            default:
                return <p>Sorry, this report is not properly configured!</p>;
        }
    };

    return (
        <Paper>
            <FBMAccountPicker fromReportScreen={true} />

            <Grid container>
                <Grid item xs={4}>
                    <span style={{ fontWeight: 'bold', paddingRight: '25px' }}>Report Type:</span>
                    <Select id="frmSelectReport" value={currentReport} onChange={handleSelectReportChange}>
                        {reportList.map((report) => (
                            <MenuItem key={report.id} value={report.id}>
                                {report.displayName}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
            </Grid>

            {renderSelectedReport()}
        </Paper>
    );
};

export { FBMViewReports };
